import { AssetType } from '../enums/AssetType'
import { AssetGroup } from './AssetGroup'
import { Aurora } from './Aurora'
import Company from './Company'
import Device from './Device'
import Level from './Level'
import Lift from './Lift'
import Project from './Project'
import RuuviTag from './RuuviTag'
import { Upload } from './Upload'

export enum AssetStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export type Asset = {
  id: string
  type: AssetType
  name: string
  description: string | null
  status: AssetStatus
  group?: AssetGroup | null
  groupId: string | null
  company?: Company | null
  companyId: number | null
  project?: Project | null
  projectId: number | null
  level?: Level | null
  levelId: number | null
  lift?: Lift | null
  liftId: number | null
  device?: Device | null
  deviceName: string | null
  ruuviTag?: RuuviTag | null
  ruuviTagId: string | null
  aurora?: Aurora | null
  auroraId: string | null
  photo?: Upload | null
  photoId: string | null
  photoUrl?: string | null
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  attachedAt?: string | null
  detachedAt?: string | null
}

export interface AuroraAsset extends Asset {
  type: AssetType.AURORA
  aurora: Aurora
  auroraId: string
  deviceId: never
  device: never
  ruuviTagId: never
  ruuviTag: never
}

export interface DeviceAsset extends Asset {
  type: AssetType.DEVICE
  device: Device
  deviceId: string
  auroraId: never
  aurora: never
  ruuviTagId: never
  ruuviTag: never
}

export interface RuuviTagAsset extends Asset {
  type: AssetType.RUUVI_TAG
  ruuviTag: RuuviTag
  ruuviTagId: string
  auroraId: never
  aurora: never
  deviceId: never
  device: never
}

export default Asset
